import { render, staticRenderFns } from "./Change.vue?vue&type=template&id=497a3240"
import script from "./Change.vue?vue&type=script&lang=js"
export * from "./Change.vue?vue&type=script&lang=js"
import style0 from "./Change.vue?vue&type=style&index=0&id=497a3240&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports